import { AxiosInstance } from 'axios';
import {
  StopServicesEndpoint,
  SearchStopsResponse,
  SearchStopsRequest,
} from './StopServices.types';

export class StopServices implements StopServicesEndpoint {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(request: SearchStopsRequest) {
    return this.instance.get<SearchStopsResponse>('/stops', {
      params: request.queryParams,
    });
  }
}
